import styled from "styled-components";
import { theme } from "../../../Theme/theme";

export const Title = styled.h4`
    color: ${theme.palette.disabled.main};
    font-weight: 400
`